import { SceneMana } from './SceneMana'
import { LHFEventDispatcher } from '../com/LHFEventDispatcher'
import { Clock, Vector2 } from 'three'
import * as TWEEN from 'tween.js'
import { OEEvents } from '../ts/core/OEEvents'
import { PanoScene } from './panorama/PanoScene'
import { PanoRenderMain } from './panorama/PanoRenderMain'

class WebGLScene extends LHFEventDispatcher {
  constructor(dom, language_) {
    super()
    this.language = language_
    this.container = dom
    // this.loadingDom = document.getElementById('loading_dom')
    // this.loadingSpan = this.loadingDom.getElementsByTagName('span')[0]
    window.modelMana = this.modelMana
    this.resizeTween = { ratio: 0 }
    this.clock = new Clock()
    this.tweenResize = new TWEEN.Tween(this.resizeTween)
    this.tweenResize.onUpdate(this.tweenResizeHandler)
    this.init()
  }

  /**
   * 添加模型加载队列
   * @param name_
   * @param url
   * @param type
   * @param childName
   */
  addZipFBX(name_, url, type, childName) {
    this.modelMana.addModels(name_, url, type, childName)
  }

  /**   * 刷新加载进度   */
  updateLoadProgress = e_ => {
    console.log('loading progress')
    // this.loadingSpan.innerText = 'loading... ' + e_.event.loadRatio + '%'
    // if (e_.event.loadRatio >= 100) {
    //   this.loadingSpan.innerText = 'parsing models, please wait'
    // }
  }

  init() {
    this.renderMain = new PanoRenderMain(this.container)
    //this.renderMain.control
    //this.renderMain.control.rotateLeft()
    //this.renderMain.control.rotateUp()
    this.sceneMana = new SceneMana(this.renderMain, this.container)
    this.mainScene = new PanoScene(
      this.renderMain,
      this.renderMain.camera,
      this.container
    )
    this.sceneMana.setScene('main', this.mainScene)
    this.sceneMana.changeScene('main')

    this.downPoint = new Vector2()
    this.enterframeInterval = -1
    this.loading = false
    this.enabled = true
    this.windowResize()
    window.addEventListener('resize', this.windowResize)
    this.enterframe()

    // 隐藏加载
    //this.loadingDom.style.display = 'none'

    // this.addRaycaster();
  }
  TweenResize() {
    return new Promise((resolve, reject) => {
      this.resizeTween.ratio = 0
      this.tweenResize.stop()
      this.tweenResize.to({ ratio: 100 }).start()
      this.tweenResize.onComplete(() => {
        resolve()
        this.tweenResize.onComplete(null)
      })
    })
  }

  tweenResizeHandler = () => {
    this.windowResize()
    this.renderMain.render()
  }
  windowResize = () => {
    let width_ = this.container.clientWidth
    let height_ = this.container.clientHeight
    this.renderMain.resize(width_, height_)
  }
  enterframe = () => {
    this.enterframeInterval = requestAnimationFrame(this.enterframe)
    if (!this.enabled) return
    let delta = this.clock.getDelta()
    this.sceneMana.updata(delta)
    this.renderMain.render(delta)

    // this.renderMain.control.rotateLeft(0.1);

    TWEEN.update()
  }

  dispose() {
    window.removeEventListener('resize', this.windowResize)
    this.container.removeEventListener('mousedown', this._mouseDownHandler)
    this.container.removeEventListener('mouseup', this._mouseUpHandler)
    this.modelMana.removeEventListener(
      OEEvents.LOAD_COMPLETE,
      this.modelLoadCompleteHandler
    )
    this.modelMana.removeEventListener(
      OEEvents.LOAD_PROGRESS,
      this.updateLoadProgress
    )
    this.renderMain.removeAllEventListener()
    this.renderMain.dispose()
    this.mainScene._listeners = {}
    this.mainScene.dispose()
    cancelAnimationFrame(this.enterframeInterval)
  }
}

export { WebGLScene }



// WEBPACK FOOTER //
// ./src/webgl/WebGLScene.js